import {Injectable} from "@angular/core";
import {CheckitEvent, Plan} from "../pages/checkit-dashboard/checkit.model";
import { Subscription } from "./core.model";
import {BehaviorSubject} from "rxjs/BehaviorSubject"
import {AngularFirestoreCollection, AngularFirestore} from "angularfire2/firestore";
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import {StripeObject, SubscriptionPlan} from "../payment/models";
import {ReplaySubject, ConnectableObservable} from "rxjs/Rx";
import { map } from 'rxjs/operators';
// import { create } from 'rxjs/observable/create';
/**
 * Created by greg on 9/03/2018.
 */



export interface Collections {
    events?: Observable<CheckitEvent[]>;
    available_events?: Observable<CheckitEvent[]>;
    registrants?: Observable<any[]>;
}

@Injectable()
export class StateService {

    // called on clean state -- currently not used
    $destroy: Subject<boolean> = new Subject();
    // Used as a bus to transfer event requests: checkit-dashboard.ts and account.ts use it
    public $requests: Subject<any> = new Subject();
    // holds data on account
    public accounts: Object = { currentId: '', available: [] };
    // not used yet
    public tooltips: Object = { engaged: true  };
    // holds checkit state data
    public checkit;
    // holds current subscription object stream
    public account$: Observable<any>;
    public subscription: Observable<Subscription>;
    public subscription_object:Subscription;
    // holds current settings object stream
    public settings//: Observable<any>;
    // holds displayed events stream
    public events$: Observable<CheckitEvent[]> = Observable.of([]);
    public events:Array<CheckitEvent> = [];
    // holds displayed selected event or nothing
    public current_event$: Observable<CheckitEvent> = Observable.of(null);
    public active_events: number = 0;
    public footer = {show_banner: ''};
    // ??
    public uid;
    public user_settings = {};
    // ??
    //public events: Observable<CheckitEvent[]>;
    // ??
    public collections: Collections;
    // ??
    public $eventsSet: Subject<boolean> = new Subject();
    public screen: Subject<any> = new Subject();
    public accountStatus = '';
    public $function_rules: Observable<any> = Observable.of({});
    public rules: any = {};

    constructor(private afs: AngularFirestore){
        afs.firestore.settings({timestampsInSnapshots: true});
        this.cleanState();
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() + 30);
        // const expiration = new Date(d.valueOf() * 60000);
        this.$requests.subscribe(request=>{
            switch (request.request){
                case 'setCustomIdUsage':
                    this.checkit.event.use_custom_id = request.use_custom_id;
                    console.log(' this.checkit.event ',this.checkit.event)
                    break;
            }
        })

    }

    setAccount(key, value, uid, settings?){
        this.uid = uid;
        this.user_settings = Object['assign'](this.user_settings,settings);
        this.accounts[key] = value;
        console.log('setAccount called ',settings)
        if(key == 'currentId'){
            this.account$ = this.afs.doc<any>(`accounts/${value}`).valueChanges();
            this.setEvents(uid);
            this.account$.subscribe(account=>{
                this.subscription_object = account.subscription;
                this.settings = account.settings;
                if(account.subscription.plan == 'free'){
                    this.footer.show_banner = 'subscribe';
                    const now = Date.now();
                    const exp = account.subscription.expiration.toDate();
                    const diff = Math.floor((exp - now) / 1000 / 60 / 60 / 24);
                    account.subscription['days_til_end'] = diff;
                    this.accountStatus = diff >= 0 ? 'account-current' : 'account-suspended';
                } else {
                    // TODO: The account status need to be handled if payment failed
                    this.accountStatus = 'account-current';
                    // this.accountStatus.next('account-current');
                }
                this.$requests.next({request:'subscriptionStatusSet',subscription:account.subscription});
            })
        }
        this.$function_rules = this.afs.collection(`checkit-rules`).snapshotChanges().pipe(
            map(actions => {
                const rules = {};
                actions.forEach( a => {
                    rules[a.payload.doc.id] = a.payload.doc.data()
                });
                return rules;
            })
        );
        this.$function_rules.subscribe( rules => this.rules = rules);
    }

    setEvents(uid?){ // uid will be helpful when users events are in different accounts
        if (this.accounts['currentId']) {
            this.events$ = this.afs.collection<CheckitEvent>(`accounts/${this.accounts['currentId']}/events`).valueChanges();
        }
        this.events$.subscribe(events => {
            this.active_events = 0;
            this.events = events;
            const midnight = this.midnight();
            console.log('TODO: Find out how to stop this from calling twice, but still work when someone first logs in!')
            events.forEach(evnt => {
                if (!evnt.closed) {
                    this.active_events++;
                }
            })
        });
    }

    setEvent(eventId){
        if(!this.accounts['currentId']) return;
        this.current_event$ = this.afs.doc<CheckitEvent>(`accounts/${this.accounts['currentId']}/events/${eventId}`).valueChanges();
    }

    cleanState(){
        this.$destroy.next(true);
        this.accounts = { currentId: '', available: [] };
        this.tooltips = { engaged: true };
        this.checkit = {
            page: 'events',
            event: null,
            import: null,
            events:{ search_category: 'Events', loaded_events: {} }
        };
        this.collections = {}
    }
    midnight() {
        const d = new Date();
        d.setHours(0,0,0,0);
        return d;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/state.service.ts